import { Container, Stack } from '@mui/material';
import React from 'react';

import { Page } from '../../../../components';
import HeaderBreadcrumbs from '../../../../components/header-breadcrumbs';
import { DeviceList } from '../../../../components/lists/devices-list';

export const DeviceListScreen: React.FC = () => {
    return (
        <Page title="POM - Devices">
            <Container maxWidth={false}>
                <Stack direction="row" alignItems="center" justifyContent="space-between">
                    <HeaderBreadcrumbs
                        heading="Devices"
                        links={[
                            {
                                name: 'List of POM Devices available in your subscription.',
                                href: '/devices'
                            },
                        ]}
                        activeLast={false}
                    />
                </Stack>
                <DeviceList />
            </Container>
        </Page>
    )
}